import Lotteries from './Lotteries';

export default Lotteries;
